import { api } from "../client";
import type { Tag } from "../types";

export const tagApi = {
  list: () => api<{ status: string; data: Tag[] }>("tag/gettags").then((r) => r.data ?? []),
  add: (description: string, isPublic: boolean) =>
    api<{ status: string; message: string }>("tag/addtag", { body: { description, isPublic } }),
  remove: (id: number, description?: string) =>
    api<{ status: string; message: string }>("tag/removetag", { body: { id, description } }),
};
